import { controls,grouped } from "../controls";
const crb = {
label: "Transaction",
pageLabel: "Transaction",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
isTransaction:true,
filter:[
]
,form:[

            ...grouped.trnsummary(),
            ...grouped.denominationtrn(),
            
        {
          widths: "col-sm-9",
          tab: "general",
          style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
          direction: 'vertical',
          pagination: { perPage: 30, buttonSize: 'col-sm-2' },
          subComponents: [
          
          ]
        },grouped.acinfo('general')]
, history:{
perPage: 10,
reportHeader: "Transaction",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Createdby",accessor: "createdby",},
{Header: "Updatedat",accessor: "updatedat",type:'date'},
{Header: "Total Credits",accessor: "total_credits",},
{Header: "Crb Active",accessor: "crb_active",type:'tick'},
]}};
export default crb;